import { FinancingTypeEnum as TPatientFinancingPlanType } from "@/api/generated/patient/general.types";

export { TPatientFinancingPlanType };

export interface TPatientFinancingPlan {
  id: string;
  patient: string;
  financing_type: TPatientFinancingPlanType | null;
}

// export enum TPatientFinancingPlanType {
//   CASH = "cash",
//   ORTHO_FI = "ortho_fi",
// }

// if modified also modify in: tests/singleWorker/patientFlow/flow.spec.ts
export const ORTHO_FI_URL = "https://login.orthofi.com/sign-in";
